import { SectionItemI } from "../../shared/item";
import { StoreWallInterface } from "../types/store";

export interface RodChainInfo {
    itemId: string;
    shouldUseAltId: boolean;
}

export const getRodChainIds = (sections: StoreWallInterface["sections"]): RodChainInfo[] => {
    const results: RodChainInfo[] = [];
    
    // Собираем все штанги из всех секций с информацией о секции
    const allRods: (SectionItemI & { sectionIndex: number })[] = [];
    sections.forEach((section, sectionIndex) => {
        const rods = section.items.filter(item => 
            item.type?.some((t) => t === "Штанга") && !item.isSpirit
        );
        rods.forEach(rod => {
            allRods.push({ ...rod, sectionIndex });
        });
    });
    
    if (allRods.length === 0) {
        return results;
    }
    
    // Группируем штанги по высоте (Y) и глубине
    const groups = new Map<string, (SectionItemI & { sectionIndex: number })[]>();
    
    allRods.forEach(rod => {
        const heightKey = Math.round(rod.position[1] * 1000); // округляем для точности сравнения
        const depthKey = Math.round(rod.depth);
        const key = `${heightKey}_${depthKey}`;
        
        if (!groups.has(key)) {
            groups.set(key, []);
        }
        groups.get(key)!.push(rod);
    });
    
    // Для каждой группы определяем горизонтальную цепочку
    groups.forEach((group, key) => {
        console.log(`Группа штанг на высоте/глубине ${key}:`, group.map(r => ({ 
            name: r.name, 
            sectionIndex: r.sectionIndex, 
            id: r.id 
        })));
        
        if (group.length <= 1) {
            // Одиночная штанга на этой высоте/глубине
            results.push({ itemId: group[0].id, shouldUseAltId: false });
            return;
        }
        
        // Сортируем по индексу секции (слева направо)
        group.sort((a, b) => a.sectionIndex - b.sectionIndex);
        
        // Первая штанга слева (в первой секции) всегда использует обычный ID
        console.log(`Штанга ${group[0].name} в секции ${group[0].sectionIndex} - первая в цепи -> основной ID`);
        results.push({ itemId: group[0].id, shouldUseAltId: false });
        
        // Для остальных штанг проверяем непрерывность цепи по секциям
        for (let i = 1; i < group.length; i++) {
            const currentRod = group[i];
            const prevRod = group[i - 1];
            
            // Проверяем, что секции идут подряд и глубины одинаковые
            const isConsecutiveSection = currentRod.sectionIndex === prevRod.sectionIndex + 1;
            const hasSameDepth = Math.abs(currentRod.depth - prevRod.depth) < 10; // допуск 1см
            
            // Если цепь продолжается, используем альтернативный ID
            if (isConsecutiveSection && hasSameDepth) {
                console.log(`Штанга ${currentRod.name} в секции ${currentRod.sectionIndex} продолжает цепь -> альтернативный ID`);
                results.push({ itemId: currentRod.id, shouldUseAltId: true });
            } else {
                console.log(`Штанга ${currentRod.name} в секции ${currentRod.sectionIndex} прерывает цепь -> основной ID`);
                results.push({ itemId: currentRod.id, shouldUseAltId: false });
            }
        }
    });
    
    return results;
};